import { useConfiguration } from '../../../../store/configurationStore';
import { UIInstrumentType } from '../../../../types/generatedTypes';
import { SectionId } from '../types';
import { Section } from '../../../../store/configurationStore/types';
import { ValidationResult } from '../validation/types';

interface UseSectionDataParams {
  templateId: string;
  instrumentType: UIInstrumentType;
  sectionId: SectionId;
}

interface UseSectionDataReturn {
  section: Section | undefined;
  selectedColumn: string | null;
  validationResult: ValidationResult | null;
}

export const useSectionData = (
  params: UseSectionDataParams
): UseSectionDataReturn => {
  const { templateId, instrumentType, sectionId } = params;
  const { templates, getValidationForSection } = useConfiguration();

  // Navigate: templates → template → instrumentConfig → section
  const template = templates.find(t => t.id === templateId);
  const instrumentConfig = template?.instrumentConfigs.find(
    ic => ic.instrumentType === instrumentType
  );
  const section = instrumentConfig?.sections.find(s => s.id === sectionId);

  // Get selected column from first column mapping
  const selectedColumn = section?.config.columnMappings?.[0]?.sourceColumn || null;

  // Get validation
  const validationResult = getValidationForSection(sectionId);

  return {
    section,
    selectedColumn,
    validationResult,
  };
};
